import React, { useState, useEffect, useContext, useRef } from "react";
import { Outlet } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import { Suspense } from "react";
import axios from "axios";
import { ConfigContext } from "../Context/ConfigContext";
import MobileHeader from "./MobileHeader";
import { jwtDecode } from "jwt-decode";
import Sidebar from "./Sidebar";
import UniCarSearch from "../Pages/Cars/UniCarSearch";
import WelcomeHomePopup from "../Components/WelcomeHomePopup";

const AppLayout = () => {

  const {
    setLang,
    setWindowResize,
    setCartItemsQty,
    setLoginStatus,
    apiB2BURL,
    token,
    setShowLoginPopup,
    showLoginPopup,
    closePopup
  } = useContext(ConfigContext);

  useEffect(() => {
    if (localStorage.getItem("AccountLocked") === "" || localStorage.getItem("AccountLocked") === "unlock") {
      GetBusinessInfo();
    }
  }, [])

  useEffect(() => {
    localStorage.setItem('dir', 'ltr');
    if (localStorage.getItem('lang') === 'ar') {
      localStorage.setItem('dir', 'rtl');
    }
    setLang(localStorage.getItem('selectedLanguage') ? localStorage.getItem('selectedLanguage') : 'en');
    setCartItemsQty();
    setWindowResize({
      isMobile: window.innerWidth <= 768,
      loading: false,
      error: null,
    });
    CheckLogin();
  }, []);

  useEffect(() => {

    if (
      localStorage.getItem("token") &&
      localStorage.getItem("business_id") &&
      localStorage.getItem("popup_seen") !== "yes"
    ) {
      setShowLoginPopup(true);
    }

  }, []);

  const GetBusinessInfo = () => {
    const business_id = localStorage.getItem("business_id");
    const business_user_id = localStorage.getItem("business_user_id");
    const headers = {
      token: token,
      businessid: String(business_id),
      businessuserid: String(business_user_id),
      Accept: "application/json",
      "Content-Type": "application/json"
    };
    var config = {
      method: 'get',
      url: `${apiB2BURL}/Customer/Users/GetBusinessInfo?business_id=${business_id}`,
      headers: headers
    };
    axios(config)
      .then(function (response) {
        const data = response.data;

        if (data.lock) {
          localStorage.setItem("AccountLocked", "lock");

          window.location.href = "/AccountLocked";
        } else {
          localStorage.setItem("AccountLocked", "unlock");
        }
        //  }

      })
      .catch(function (error) {
      });
  }
  // Check login status
  const CheckLogin = () => {
    if (!localStorage.getItem('token')) {
      setLoginStatus(false);
      return false;
    }
    const token = localStorage.getItem('token');
    const decodedToken = jwtDecode(token);
    const currentDate = new Date();

    if (decodedToken.exp * 1000 < currentDate.getTime()) {
      setLoginStatus(false);
      return false;
    } else {
      setLoginStatus(true);
    }
  };

  const mobileDrawerRef = useRef(null);
  const openDrawer = () => {
    if (mobileDrawerRef.current) {
      mobileDrawerRef.current.style.transform = "translateX(0)";
      mobileDrawerRef.current.style.zIndex = "10000000000000000";
    }
  }
  const closeDrawer = (bool) => {
    if (bool) {
      setShowModal(true);
    }
    if (mobileDrawerRef.current) {
      mobileDrawerRef.current.style.transform = "translateX(-100%)";
    }
  }

  const [isMobile, setIsMobile] = useState(false);

  const handleResize = () => {
    setIsMobile(window.innerWidth <= 768);
  };

  useEffect(() => {
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const dir = localStorage.getItem("dir");
  const [showModal, setShowModal] = useState();
  const divRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (divRef.current && !divRef.current.contains(event.target)) {
        setShowModal(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <>
      <div className="page-wrapper" dir={dir} style={{ color: '#132530' }}>
        <Sidebar />
        {
          isMobile ?
            <MobileHeader />
            :
            <Header isMobile={isMobile} openDrawer={openDrawer} closeDrawer={closeDrawer} />
        }

        <main className="main">
          <Suspense fallback={<div>Loading...</div>}>
            <Outlet />
          </Suspense>
        </main>
        <Footer />
        <WelcomeHomePopup
          show={showLoginPopup}
          onClose={closePopup}
        />
      </div>


      <div className={`modal fade ${showModal ? 'show d-block' : 'd-none'}`}
        id="subcatsModal"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="subcatsModalLabel"
        aria-hidden="true"
        style={{ backgroundColor: 'rgba(0, 0, 0, 0.5)', zIndex: 100000000 }}>

        <div ref={divRef} className="modal-dialog " role="document" >
          <div className="modal-content">
            <div className="modal-body">
              <div className="container">
                <UniCarSearch setShowModalGarage={setShowModal} />
              </div>
            </div>
          </div>
        </div>
      </div>

    </>
  );
};

export default AppLayout;
